/* Overland Testimonials carousel — minimal scroll-snap navigation */
(function () {
  function init(section) {
    const track = section.querySelector('.of-testimonials__track');
    const dots = section.querySelectorAll('.of-testimonials__dot');
    const prevBtn = section.querySelector('.of-testimonials__nav--prev');
    const nextBtn = section.querySelector('.of-testimonials__nav--next');
    if (!track) return;

    const scrollByCard = (dir) => {
      const card = track.querySelector('.of-testimonial');
      if (!card) return;
      const styles = window.getComputedStyle(track);
      const gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      let target = track.scrollLeft + dir * distance;
      if (target < 0) target = 0;
      if (target > max) target = max;
      track.scrollTo({ left: target, behavior: 'smooth' });
    };

    const updateNavState = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (prevBtn) prevBtn.toggleAttribute('disabled', track.scrollLeft <= 1);
      if (nextBtn) nextBtn.toggleAttribute('disabled', track.scrollLeft >= max - 1);
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scrollByCard(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollByCard(1));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const cards = track.querySelectorAll('.of-testimonial');
        if (cards[i]) {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    // Dev QA 595:719 — dots represent SCROLL PAGES, not cards. With N cards and
    // V visible per view there are only N - V + 1 snap positions; hide the rest
    // (e.g. 3 cards 2-up on desktop -> 2 dots; 1-up on mobile -> 3 dots).
    const pageCount = () => {
      const cards = track.querySelectorAll('.of-testimonial');
      if (!cards.length) return 0;
      const styles = window.getComputedStyle(track);
      const gap = parseInt(styles.columnGap || styles.gap || '0', 10) || 0;
      const per = cards[0].getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.round((track.clientWidth + gap) / per));
      return Math.max(1, cards.length - visible + 1);
    };

    const updateDotVisibility = () => {
      const pages = pageCount();
      dots.forEach((dot, i) => {
        dot.toggleAttribute('hidden', i >= pages);
      });
    };

    // Update active dot on scroll
    const updateActiveDot = () => {
      const cards = track.querySelectorAll('.of-testimonial');
      const pages = pageCount();
      let activeIndex = 0;
      let minDelta = Infinity;
      cards.forEach((card, i) => {
        const delta = Math.abs(card.getBoundingClientRect().left - track.getBoundingClientRect().left);
        if (delta < minDelta) {
          minDelta = delta;
          activeIndex = i;
        }
      });
      if (activeIndex > pages - 1) activeIndex = pages - 1;
      dots.forEach((dot, i) => {
        dot.toggleAttribute('aria-current', i === activeIndex);
        dot.classList.toggle('is-active', i === activeIndex);
      });
    };

    track.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(() => {
          updateActiveDot();
          updateNavState();
        });
      },
      { passive: true },
    );
    updateDotVisibility();
    updateActiveDot();
    updateNavState();
    window.addEventListener(
      'resize',
      () => {
        updateDotVisibility();
        updateActiveDot();
        updateNavState();
      },
      { passive: true },
    );
  }

  document.querySelectorAll('.of-testimonials').forEach(init);

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('section-overland-testimonials')) {
      init(e.target.querySelector('.of-testimonials') || e.target);
    }
  });
})();
